import { createSlice } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react';
// import utils from '../../utils/utils';
import { cwreport } from '../../cw_center/cw-report';
import { transportReport } from '../../cw_center/global';
import { getShopifyIdToken } from '../../cw_center/getToken';

const initialState = {
    status: false, // 是否获取公共数据
    message: '', // 接口提示
    publicInit: {}, // 公共数据
    resNum: 0,
    error: {}, // 请求状态
    pageInit: {
        recommended: {}, // 中台页面缓存
        SEOChecker: {}, // SEO Checker
        GoogleAnalytics: null, // 谷歌分析登录
        MetaTags: null, // 元标签元描述页面缓存
        ExchangeBacklink: {}, //外链互换
        onPage: {}, // onpage页面缓存 
        htmlSitemap: {
            isResetLoading: false, // 页面btn-loading
            getStructuredData: {}
        }, // html站点地图页面缓存
        speedAnalysis: {}, // speed页面缓存
        jsonLD: {}, // jsonLD页面缓存
        integration: {
            isResetLoading: false, // 页面btn-loading
            getShopifyPrimary: {}
        }, // 功能集合页面缓存
        pricingPlan: null, // 价格页面缓存
    },
    window_width: window.innerWidth,
    window_scrollY: 0,
    tinymce_info: false, // 富文本加载状态
    shopOwner: '', // 店铺用户名称
    domain: '', // 店铺域名
    email: '', // 店铺邮箱
    topId: 0, // 默认首页0
    topSonId: 0, // 默认0第一个
    Language: '', // 默认空
    payTipStatus: 0, // 支付提示信息
    ActMealData: {}, // 改版活动数据
    InstantPageSwitch: -1, // instant状态
    level: 1, // 默认1
    imageOptAuto: false, // 图片压缩 自动开关状态
    imageAltAuto: false, // 图片Alt 自动开关状态
    uid: -1, // 用户id
    isShowTopMenu: true, // 测试对象状态
    AllAdverData: {},   // 广告配置数据
    isComboUser: false,     // 是否组合套餐用户
    isHiddenScroll: false,     // 是否操作了滚动条
    shopDomain: '',         // shopify 域名
    shopifyLangState: false,    // 是否已设置shopify语言
    appLangState: false,        // 是否已设置app语言
    OnpageListParams: {
        state: 1,
        params: {},
    },       // onpage列表参数
    windowData: null,
    trial_days: -1, // 试用天数
    planPageViews: 0, // 套餐页访问次数
    guideVerify: true, // 新手引导验证状态
    aiGuideList: [], // 创作指导列表
    themeExtensionRes: null, // 主题扩展状态
    floatingState: {
        isShowGuide: false,
        isShowSmallBlock: true,
        isSet: 0,
    },
    created_at: '', // 创建时间
    setInitCWTracks: false, // 是否初始化CWTracks
    mainLanguage: 'en', // 主语言
    isInitSentry: false, // 是否初始化Sentry
    isInitLogRocket: false, // 是否初始化LogRocket
    chatwill_installed: -1, // 是否安装chatwill
    homeStreamData: {
        seo_data: {},
        campaign_data: {},
        other_options: {},
        chatwill: {},
    }, // 首页流式数据
    initAmpTabsState: false, // 是否初始化amp状态
    initAmpPageState: false, // 是否初始化amp页面状态
    initAmpNavState: false, // 是否初始化amp导航状态
    cwreportInitialized: false, // 是否初始化posthog埋点
    upgradePosition: '', // 升级位置
    MidIntercomInfo: {
        exist: false, // 是否存在
        intercom_user_jwt: '', // jwt
    }
}

export const publicData = createSlice({
    name: 'public',
    initialState,
    reducers: {
        // 线上调用shopify app接口的数据，直接设置全局状态
        //   设置公共数据
        setPublicData: (state, action) => {
            state.publicInit = action.payload.data;
            if (action.payload.ack === 1) {
                const _that = action.payload.data.shop_data;  // 用户数据
                const uid = _that.id;   // 用户id
                state.status = true; // 拿到数据设置为true
                state.uid = uid;
                state.shopOwner = _that.shop_owner;
                state.domain = _that.domain;
                state.shopDomain = _that.name;
                state.email = _that.email;
                state.level = _that.level;
                state.isComboUser = action.payload.data.head_data?.is_combo_plan;
                state.created_at = _that.created_at;
                state.mainLanguage = _that.content_language;
                // 判断是否内嵌模式
                // const params = new URLSearchParams(window.location.search);
                // const shop = params.get("shop");
                // const host = params.get("host");
                // 判断是否兼容shopify语言
                let spf_Lang = _that.language;
                if (!window.shopify) {
                    state.Language = spf_Lang;
                    window.Language = spf_Lang;
                }

                // 前端监控
                if (window.__bl && window.__bl.setConfig) {
                    window.__bl.setConfig({
                        setUsername: function () {
                            return _that.domain;
                        },
                        uid: _that.domain,
                        domain: window.location.hostname
                    });
                }

                // Hotjar
                // if (window.hj) {
                //     const userId = uid || null;
                //     window.hj('identify', userId, {// Add your own custom attributes here. Some EXAMPLES:
                //         name: _that.name,
                //         domain: _that.domain,
                //         level: _that.level,
                //         Shopify_Merchant_type: _that.plan_display_name,
                //     });
                // }

                let d_name = _that?.plan_display_name || '';
                // LogRocket 埋点
                // try {
                //     // id 大于90680 seoLocal@tt.com
                //     if (window.shopify && window.LogRocket && !(d_name.includes('Developer') || d_name.includes('Development')) && uid > 90680 && !state.isInitLogRocket) {
                //         state.isInitLogRocket = true;
                //         window.LogRocket.init('vk1heg/will-number-two');
                //         window.LogRocket.identify(_that.name, {
                //             name: _that.name,
                //         });
                //     }
                // } catch { }

                // Sentry 视频监控
                try {
                    if (window.shopify && !(d_name.includes('Developer') || d_name.includes('Development')) && !state.isInitSentry) {
                        state.isInitSentry = true;

                        // 初始化状态
                        Sentry.init({
                            dsn: "https://ec9a1337027aff0b5e1e131f4dc6b586@o4510085723586560.ingest.us.sentry.io/4511300747264000",
                            // Setting this option to true will send default PII data to Sentry.
                            // For example, automatic IP address collection on events
                            sendDefaultPii: true,
                            // 注入 Replay 模块
                            integrations: [Sentry.replayIntegration({
                                // 1. 允许记录所有 URL 的详情
                                networkDetailAllowUrls: [/.*/],
                                // 2. 核心：必须开启此项才能看到请求和响应的数据包内容
                                networkCaptureBodies: true,
                                // 3. 记录所有 Header（或者根据需要筛选）
                                networkRequestHeaders: ['Content-Type', 'Authorization', 'X-Custom-Header'],
                                networkResponseHeaders: ['Content-Type', 'X-Custom-Header'],
                                // 掩码配置（可选）：隐藏所有文本内容以保护隐私
                                maskAllText: false,
                                blockAllMedia: false,
                            }),
                            // 记录500错误
                            Sentry.httpClientIntegration({
                                failedRequestStatusCodes: [500]
                            }),
                            ],
                            // 错误采样率：1.0 表示发生错误时记录整个会话（生产环境常用）
                            replaysOnErrorSampleRate: 1.0,
                        });

                        // 设置Sentry标记
                        Sentry.setUser({
                            id: _that.id,
                            name: _that.name,
                        })
                    }
                } catch { }

                // 关闭启动动画 
                // eslint-disable-next-line no-unused-expressions
                window?.hideLoadingState();

                try {
                    // cio 埋点
                    const CompLang = {
                        "cs": "cs",
                        "da": "da",
                        "ge": "de",
                        "en": "en",
                        "sp": "es",
                        "fr": "fr",
                        "it": "it",
                        "in": "in",
                        "dut": "nl",
                        "nb": "nb",
                        "pl": "pl",
                        "pt_BR": "pt-BR",
                        "pt": "pt-PT",
                        "fi": "fi",
                        "sv": "sv",
                        "tr": "tr",
                        "th": "th",
                        "ja": "ja",
                        "zh": "zh-CN",
                        "zh_hant": "zh-TW",
                        "ko": "ko",
                    }
                    // let creatAt = utils.timeFormat(_that?.created_at || 0);
                    if (window.shopify && _that.name && !Boolean(window.cio?.initialized)) {
                        window.cio?.init({
                            id: _that.name,
                            shop_owner: _that.shop_owner,
                            email: _that.email,
                            shop_name: _that.shopname,
                            shop_domain: _that.name,
                            shop_plan: _that.plan_display_name,
                            app_name: 'Seoant',                             // 应用名称，详见下方说明
                            language: CompLang[_that.language] || 'en',     // 语言简码
                            shopify_plan: _that.plan_display_name,          // Shopify套餐
                            country_name: _that.country_code,
                            city: _that.city,                               // 可选
                        })
                    }
                    // country_name: _that.country,
                    // shop_plan: _that.level === 3 ? 'Pre Plan' : _that.level === 3 ? 'Pro Plan' : 'Free',
                    // shop_created_at: creatAt, // 可选

                    // posthog埋点
                    if (window.shopify && cwreport && !Boolean(state?.cwreportInitialized)) {
                        // 埋点 - posthog
                        state.cwreportInitialized = true;
                        const isProdEnv = process.env.REACT_APP_ARMS_ENV === 'prod';

                        cwreport.init({
                            api_key: process.env.REACT_APP_POSTHOG_API_KEY, // 自定义posthog key：根据需要将埋点上报到对应帐号上
                            app_id: '518111167165693952', // 传入appId
                            test_mode: !isProdEnv, // 测试服/本地为 true，正式服为 false
                            gzip: isProdEnv, // 正式服开启 gzip，测试服关闭方便查看请求
                            get_shopify_id_token: getShopifyIdToken,
                        });

                        // 设置用户属性
                        cwreport.identify(_that.name, {
                            shopify_domain: _that.name
                        });

                        // 注册应用
                        cwreport.register({
                            app_name: "SEOWILL",
                        });

                        // 设置公共属性
                        cwreport.initPublicProperty({
                            country_code: _that.audience_location,                       // 国家编码，示例：US
                            city: _that.country,                                         // 城市，示例：Fort Lauderdale
                            shopify_plan: _that.plan_display_name,                       // shopify店铺类型，示例：Advanced 
                            app_name: "SEOWILL",                                         // app名称
                            language: _that.language                                     // 传递语言语种，示例：en
                        });

                        // 应用启动
                        transportReport('app_start');
                    }
                } catch { }
            }
            state.msg = action.payload.msg;
        },

        // 设置广告数据
        setAllAdverData: (state, action) => {
            state.AllAdverData = action.payload;
        },

        // 改变语言状态
        changeLanguageInfo: (state, action) => {
            state.Language = action.payload;
            // 是否更新接口的数据
            const _shopData = state.publicInit?.shop_data;
            if (_shopData) {
                _shopData.language = action.payload;
            }
        },

        // 修改活动banner/轮播图状态
        changeActShowStatus: (state, action) => {
            state.homeStreamData.campaign_data.campaign_modal.top_status = action.payload[0];
            state.homeStreamData.campaign_data.campaign_modal.middle_status = action.payload[1];
        },

        // 设置宽度
        setWindowWidth: (state, action) => {
            state.window_width = action.payload;
        },

        // 设置滚动高度
        setWindowScrollY: (state, action) => {
            state.window_scrollY = action.payload;
        },

        //修改富文本加载状态
        setTinymceStatus: (state, action) => {
            state.tinymce_info = action.payload;
        },

        // 设置初始状态
        setAppPublicInit: (state) => {
            state.resNum = 1;
        },

        // 设置导航栏tabsid
        changeTabsSelectedId: (state, action) => {
            state.topId = action.payload[0];
            state.topSonId = action.payload[1];
        },

        // 设置支付提示状态
        setPayTipStatus: (state, action) => {
            state.payTipStatus = action.payload;
        },

        // 设置改版活动
        setActMealResData: (state, action) => {
            state.ActMealData = action.payload;
        },

        // 设置评价状态
        saveStartReview: (state) => {
            state.publicInit.head_data.review_tips = false;
        },

        // 设置支付回调提示状态
        savePayTip: (state) => {
            state.homeStreamData.other_options.paid_confirm = 0;
        },

        // 设置自定义缓存
        setSaveSwitchData: (state, action) => {
            state.publicInit.head_data.switch_data = action.payload;
        },

        // 设置自定义缓存 - 新手引导
        setSaveGuideSwitchData: (state, action) => {
            state.guideVerify = false;
            state.publicInit.guide_steps = action.payload;
        },

        // 设置图片压缩自动开关状态
        setImageAutoSwitchData: (state, action) => {
            state[action.payload.type] = action.payload.value;
        },

        // 设置顶部和导航栏状态
        setTopMenuState: (state, action) => {
            state.isShowTopMenu = action.payload;
        },

        // 是否设置了滚动条样式
        setScrollHiddenState: (state, action) => {
            state.isHiddenScroll = action.payload;
        },

        // 设置shopify语言
        setShopifyLang: (state, action) => {
            state.Language = action.payload;
            state.shopifyLangState = true;
        },

        // 设置app语言状态
        setLangState: (state, action) => {
            state.appLangState = action.payload;
        },

        // 缓存onpage列表参数
        setOnpageListParams: (state, action) => {
            state.OnpageListParams.state = 1;
            state.OnpageListParams.params = action.payload;
        },

        // 设置参数使用状态
        setOnpageListParamsReset: (state) => {
            state.OnpageListParams.state = 0;
        },

        // 缓存窗口通信数据
        setWindowSendData: (state, action) => {
            state.windowData = action.payload;
        },

        // 设置套餐页访问次数
        setPlanPageViews: (state) => {
            state.planPageViews++;
        },

        // 设置创作指导列表
        setAiGuideList: (state, action) => {
            state.aiGuideList = action.payload;
        },

        // 设置主题扩展状态
        setThemeExtensionRes: (state, action) => {
            state.themeExtensionRes = action.payload;
        },

        // 设置浮动状态
        setFloatingState: (state, action) => {
            state.floatingState = {
                isSet: 1,
                isShowGuide: action.payload.isShowGuide,
                isShowSmallBlock: action.payload.isShowSmallBlock,
            }
        },

        // 设置是否初始化CWTracks
        setInitCWTracksState: (state, action) => {
            state.setInitCWTracks = action.payload;
        },

        // 设置是否安装chatwill
        setChatwillInstalled: (state, action) => {
            state.chatwill_installed = action.payload;
        },

        // 设置首页流式数据
        setHomeStreamData: (state, action) => {
            const { type, data } = action.payload;
            state.homeStreamData[type] = data;
            if (type === 'other_options') {
                state.trial_days = data?.trial_days || 0;
            }
        },

        // 初始化amp状态
        setReduxInitTabsState: (state, action) => {
            const { type } = action.payload;
            if (type === 'tabs') {
                state.initAmpTabsState = true;
            } else if (type === 'page') {
                state.initAmpPageState = true;
            } else if (type === 'nav') {
                state.initAmpNavState = true;
            }
        },

        // 设置升级位置
        setUpgradePosition: (state, action) => {
            state.upgradePosition = action.payload;
        },

        // 设置中台 Intercom JWT
        setMidIntercomInfo: (state, action) => {
            state.MidIntercomInfo = {
                exist: Boolean(action.payload?.exist),
                intercom_user_jwt: action.payload?.jwt || '',
            };
        },
    },
})

// Action creators are generated for each case reducer function
// 为每个case reducer函数生成动作创建者
export const {
    setPublicData,
    setAllAdverData,
    changeLanguageInfo,
    changeActShowStatus,
    setWindowWidth,
    setWindowScrollY,
    setTinymceStatus,
    setAppPublicInit,
    changeTabsSelectedId,
    setPayTipStatus,
    setActMealResData,
    saveStartReview,
    savePayTip,
    setSaveSwitchData,
    setSaveGuideSwitchData,
    setImageAutoSwitchData,
    setTopMenuState,
    setScrollHiddenState,
    setShopifyLang,
    setLangState,
    setOnpageListParams,
    setOnpageListParamsReset,
    setWindowSendData,
    setPlanPageViews,
    setAiGuideList,
    setThemeExtensionRes,
    setFloatingState,
    setInitCWTracksState,
    setChatwillInstalled,
    setHomeStreamData,
    setReduxInitTabsState,
    setUpgradePosition,
    setMidIntercomInfo,

} = publicData.actions

// selector 函数允许我们从 state 中获取值
// Selectors 也可以在使用的地方内联的方式定义
// 而不是仅仅只能在 slice 文件中。例如 : `useSelector((state) => state.counter.value)`
export const selectPublicData = state => state.public

export default publicData.reducer